import { Box, Grid, Stack } from "@mui/material";
import Image from "next/image";
import Background from "../../../public/personalize-ai-background.webp";
import React, { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

const PersonalizeAiContainer: React.FC<Props> = ({ children }) => {
  return (
    <Grid
      container
      justifyContent="center"
      direction={["column-reverse", "column-reverse", "row", "row"]}
    >
      <Grid
        item
        xs={7}
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ p: [4, 4, 10, 10] }}
      >
        <Stack spacing={[4, 4, 6, 6]} width={["100%", "100%", "100%", "80%"]} margin="auto">
          {children}
        </Stack>
      </Grid>
      <Grid item xs={5}>
        <Box
          sx={{
            borderRadius: "inherit",
            position: "relative",
            minHeight: ["10vh", "10vh", "100vh", "100vh"],
            height: "100%",
          }}
        >
          <Image
            src={Background}
            alt="alt"
            quality={100}
            fill={true}
            style={{
              boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              borderRadius: "inherit",
            }}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default PersonalizeAiContainer;
